import * as Actions from '../actions';
import { reorderArray, swapArray } from 'main/components/helpers';

const initialState = {
    studentAnswers:       {},
    attemptList:          [],
    currentQuestionIndex: 'header',
    timeTaken:            0,
    student_quiz_id:      0,
    attempt:              0,
    inProgress:           false,
    courseInfo: {
        company_calendar_course_id: 0,
        Unscheduled: 0
    },
    quizGradebookInfo: {}
}

const quizViewerReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.SELECT_ANSWER):
        {
            const answer           = action.payload.answer;
            const question_id      = action.payload.question_id;
            const question_type_id = action.payload.question_type_id;

            let new_answer = '';
            switch(question_type_id) {
                case(4): // Multiple Answer
                {
                    // If no answer exists yet, store array with a single answer_id
                    if(typeof state.studentAnswers[question_id] === 'undefined') {
                        new_answer = [answer];
                    } else {
                        let found_answer = false;

                        // If answer already exists in list, remove it
                        new_answer = state.studentAnswers[question_id].filter((answer_id) => {
                            if(answer_id === answer) {
                                found_answer = true;
                                return false;
                            }
                            return true;
                        });

                        // If not found, add it to array
                        if(!found_answer) {
                            new_answer.push(answer);
                        }
                    }
                    break;
                }
                
                // Other question types; just store answer_id/student_text
                default:
                {
                    new_answer = answer;
                }
            }

            return {
                ...state,
                studentAnswers: {
                    ...state.studentAnswers,
                    ...{ [question_id]: new_answer }
                }
            };
        }

        case (Actions.SET_QUESTION):
        {
            let questionIndex          = action.payload.questionIndex;
            const questionListLength   = action.payload.questionListLength;
            const currentQuestionIndex = (state.currentQuestionIndex === 'header' ? -1 : state.currentQuestionIndex === 'score' ? questionListLength : state.currentQuestionIndex);

            switch (questionIndex)
            {
                case("NEXT"):
                {
                    questionIndex = currentQuestionIndex + 1;

                    if (questionIndex >= questionListLength) {
                        questionIndex = 'score'; 
                    }
                    break;
                }
                
                case("PREVIOUS"):
                {
                    questionIndex = currentQuestionIndex - 1;

                    if (questionIndex < 0) {
                        questionIndex = 'header';
                    }
                    break;
                }

                default: {}
            }
            
            return {
                ...state,
                currentQuestionIndex: questionIndex
            }
        }

        case (Actions.CLEAR_STUDENT_ANSWERS): 
        {
            return {
                ...initialState
            }
        }

        case (Actions.CREATE_STUDENT_QUIZ_HEADER):
        {
            const student_quiz_id = action.payload.student_quiz_id;
            const attempt         = action.payload.attempt;
            
            return {
                ...state, 
                student_quiz_id: student_quiz_id,
                attempt: attempt
            }
        }

        case (Actions.SET_ATTEMPT):
        {
            const attemptList  = action.payload;
            let currentAttempt = 1;
            
            if(attemptList.length > 0) {
                currentAttempt = Math.max.apply(Math, attemptList.map((attempt) => attempt.header.Attempt)) + 1;
            }
            
            return {
                ...state,
                attempt: currentAttempt,
                attemptList: attemptList,
            }
        }

        case (Actions.SET_QUIZ_IN_PROGRESS):
        {
            const status = action.payload;

            return {
                ...state,
                inProgress: status
            }
        }

        // Order Answer Question Type

        case (Actions.INIT_ORDER_ANSWER): {
            const { question_id, answerList } = action.payload;

            return {
                ...state,
                studentAnswers: {
                    ...state.studentAnswers,
                    ... { [question_id]: {
                        wrongList: answerList.map((answer) => {
                            return {
                                ...answer,
                                Correct: 0,
                                CorrectOrder: 0,
                            }
                        }),
                        correctList: []
                    }}
                }
            }
        }

        // source { index: 1, droppableId: "wrong" } droppableId: "wrong"index: 1__proto__: Object destination { droppableId: "correct", index: 1 }
        case (Actions.ORDER_STUDENT_ANSWER):
        {
            const { source, destination, question_id } = action.payload;
            let orderAnswer     = {};
            let source_index    = source.index;
            let dest_index      = destination.index;
            let newWrongList    = state.studentAnswers[question_id].wrongList;
            let newCorrectList  = state.studentAnswers[question_id].correctList;

            if (source.droppableId === destination.droppableId) {
                // Reorder current list
                if (source.droppableId === 'wrong') {
                    newWrongList   = reorderArray(newWrongList, source_index, dest_index);
                } else {
                    newCorrectList = reorderArray(newCorrectList, source_index, dest_index);
                }
            } else {
                // Swap answer to other list
                let result = [];

                if (source.droppableId === 'wrong') {
                    result = swapArray(newWrongList, newCorrectList, source, destination);
                } else {
                    result = swapArray(newCorrectList, newWrongList, source, destination);
                }

                newCorrectList = result['correct'];
                newWrongList   = result['wrong'];
            }

            
            return {
                ...state,
                studentAnswers: {
                    ...state.studentAnswers,
                    ...{ [question_id]: {
                        correctList: newCorrectList,
                        wrongList:   newWrongList,
                    }}
                }
            }
        }

        case(Actions.GET_COURSE_INFO):
        {
            return {
                ...state,
                courseInfo: { ...state.courseInfo, ...action.payload}
            }
        }

        case(Actions.GET_QUIZ_GRADEBOOK_INFO):
        {
            return {
                ...state,
                quizGradebookInfo: { ...state.quizGradebookInfo, ...action.payload }
            }
        }

        default:
        {
            return state;
        }

    }
}

export default quizViewerReducer;


// WEBPACK FOOTER //
// src/main/content/quiz/store/reducers/quizViewer.reducer.js